// React
import React from 'react';
// External
import { withRouter } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { connect } from 'react-redux';
// Internal
import NavbarPrimary from 'components/shared/organisms/NavbarPrimary/NavbarPrimary';
import PageTitle from 'components/shared/atoms/PageTitle/PageTitle';
import ContentCard from 'components/shared/organisms/ContentCard/ContentCard';
import FinalApprovalComponent from 'components/engraving/FinalApproval/FinalApproval';
import FooterBtnActions from 'components/shared/molecules/FooterBtnActions/FooterBtnActions';
import { updateEngraving } from 'stores/actions';
import config from 'config/config';
import signOutCognito from 'utils/signOutCognito';

class FinalApproval extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            prevStepPath: ''
        };
        this.setSteps(props.engraving.productId);
        this.formComponent = React.createRef();
    }

    async onSubmit() {
        if (!this.formComponent || !this.formComponent.current) {
            return null;
        }
        const formData = await this.formComponent.current.handleSubmit();
        if (formData) {
            this.props.updateEngraving(formData);
            if (sessionStorage.getItem(config.GUEST_TOKEN) !== null) {
                signOutCognito();
            }
            this.navigateTo('/engraving/thank-you');
        }
    }

    /**
     * Sets the navigation previous step. Only when the image option is available it will set the value to
     * navigate to image options, otherwise it'll be  engraving options
     */
    setSteps(productId) {
        if (!productId) {
            return;
        }

        fetch('../fpc_config.json')
            .then((r) => r.json())
            .then((data) => {
                const selectedConfig = data.Config_File.find((x) => x.SugarID === productId);
                if (!selectedConfig) {
                    /**
                     * @todo action an error in case something went wrong when retriving the local config details
                     */
                    return;
                }
                this.setState({
                    prevStepPath: selectedConfig.PhotoSize === '0' ? 'engraving-options' : 'image-options'
                });
            }).catch((err) => {
                console.error(err);
            });
    }

    navigateTo(path) {
        this.props.history.push({
            pathname: path,
            search: this.props.location.search
        });
    }

    render() {
        return (
            <div className="main-container">
                <NavbarPrimary hideNav />
                <div className="body-content engraving">
                    <PageTitle title="Engraving approval" />

                    <ContentCard
                        className="mt-62"
                        headerTitle="Final approval"
                        divider={false}
                    >
                        <Container fluid className="engraving-container final-approval">
                            <FinalApprovalComponent
                                wrappedComponentRef={this.formComponent}
                            />
                        </Container>
                    </ContentCard>
                </div>

                <FooterBtnActions
                    prevBtnOnCLick={() => this.navigateTo(`/engraving/${this.state.prevStepPath}`)}
                    nextBtnOnCLick={() => this.onSubmit()}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        engraving: state.engraving
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateEngraving: (engravingObj) => dispatch(updateEngraving(engravingObj))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(FinalApproval));
